import { motion } from "framer-motion";
import Card from "./Card";
import data from "../../data/software.json";

const Timeline = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
    });
  };

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-6xl mx-auto"
      >
        {/* Header */}
        <motion.div variants={itemVariants} className="text-center mb-16">
          <h1 className="font-display font-bold text-4xl md:text-5xl text-secondary-900 mb-4">
            Professional Experience
          </h1>
          <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
            My journey in software development, from early internships to senior
            roles building scalable systems and leading engineering teams.
          </p>
        </motion.div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary-500 to-accent-500"></div>

          {/* Experience Cards */}
          <div className="space-y-12">
            {data["Professional Experience"].map((experience, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className={`relative flex items-start ${
                  index % 2 === 0 ? "flex-row" : "flex-row-reverse"
                }`}
              >
                {/* Timeline Dot */}
                <div className="absolute left-6 w-4 h-4 bg-primary-500 rounded-full border-4 border-white shadow-lg z-10"></div>

                {/* Content Card */}
                <div
                  className={`flex-1 ${index % 2 === 0 ? "ml-16" : "mr-16"}`}
                >
                  <Card
                    title={experience.title}
                    company={experience.company}
                    icon={experience.icon}
                    startDate={formatDate(experience.startDate)}
                    endDate={formatDate(experience.endDate)}
                    accomplishments={experience.accomplishments}
                    isEven={index % 2 === 0}
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Summary Section */}
        <motion.div variants={itemVariants} className="mt-20 text-center">
          <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-xl p-8">
            <h3 className="font-display font-semibold text-2xl text-secondary-900 mb-4">
              Career Highlights
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary-600 mb-2">
                  6+
                </div>
                <div className="text-secondary-600">Years of Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent-600 mb-2">
                  250K+
                </div>
                <div className="text-secondary-600">Daily Orders Processed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-secondary-600 mb-2">
                  40+
                </div>
                <div className="text-secondary-600">Team Members Led</div>
              </div>
            </div>
            <p className="text-secondary-600 mt-6 max-w-2xl mx-auto">
              From building microservices at Cimpress and scaling multi-region
              APIs at Coupang to owning analytics and CMS pipelines at AoPS,
              I've consistently delivered high-impact solutions while mentoring
              teams and modernizing legacy systems with best practices.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Timeline;
